import React, { useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import {
  FileText,
  Clock,
  ChevronUp,
  ChevronDown,
  Info,
} from 'lucide-react';

const UploadGuidelines = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const guidelinesRef = useRef(null);

  const handleClickOutside = (event) => {
    if (guidelinesRef.current && !guidelinesRef.current.contains(event.target)) {
      setIsExpanded(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={guidelinesRef}
      className="bg-white rounded-lg border border-gray-200 shadow-sm z-10 transition-all duration-300 ease-in-out overflow-hidden"
      style={{ width: isExpanded ? "385px" : "355px", maxHeight: isExpanded ? "500px" : "48px", maxWidth: '100%' }}
    >
      <div
        className="flex items-center justify-between p-3 cursor-pointer mb-2"
        onClick={() => setIsExpanded(!isExpanded)}
        role="button"
        aria-expanded={isExpanded}
        aria-controls="guidelines-content"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            setIsExpanded(!isExpanded)
          }
        }}
      >
        <h3 className="font-medium text-gray-800 whitespace-nowrap text-sm md:text-base">Bank Statement Upload Guidelines</h3>
        {isExpanded ? (
          <ChevronUp className="h-4 w-4 text-gray-500 ml-2 flex-shrink-0" />
        ) : (
          <ChevronDown className="h-4 w-4 text-gray-500 ml-2 flex-shrink-0" />
        )}
      </div>

      <div
        id="guidelines-content"
        className={cn(
          "px-3 pb-3 pt-2 space-y-6 transition-all duration-300",
          isExpanded ? "opacity-100" : "opacity-0 h-0 overflow-hidden"
        )}
      >
        <div className="flex">
          <Clock className="h-5 w-5 text-gray-500 mr-2 mt-0.5 flex-shrink-0" />
          <div>
            <p className="font-medium text-gray-700 text-sm">At least 4 months of statements in PDF format</p>
            <p className="text-xs md:text-sm text-gray-500">Recent statements provide better analysis of your financial history</p>
          </div>
        </div>

        <div className="flex">
          <FileText className="h-5 w-5 text-gray-500 mr-2 mt-0.5 flex-shrink-0" />
          <div>
            <p className="font-medium text-gray-700 text-sm">Maximum file size is 10MB</p>
            <p className="text-xs md:text-sm text-gray-500">Files exceeding this limit will not be processed</p>
          </div>
        </div>

        <div className="bg-blue-50 p-3 rounded-md mt-4">
          <p className="text-xs md:text-sm">
            <span className="font-semibold text-blue-700">Tip:</span>{" "}
            <span className="text-slate-800">
              Make sure your statements are monthly and not password protected for successful processing
            </span>
          </p>
        </div>
      </div>
    </div>
  )
};

export default UploadGuidelines;
